<template>
  <div>
    <div :key="rerenderKey" class="relative">
      <div ref="contentWrapper" v-if="!showAll && lines"
           class="truncate-content overflow-hidden relative" :style="{ maxHeight: `${1.5 * lines}em` }">
        <slot/>
        <div v-if="shouldShowButton"
             class="absolute bottom-0 w-full h-6 bg-gradient-to-t from-white to-transparent"></div>
      </div>
      <div v-else>
        <slot/>
      </div>
    </div>
    <div v-if="shouldShowButton" class="flex-center cursor-pointer text-secondary mx-3 pt-2.5" @click="toggleCollapse">
      <div>
        {{ showAll ? $t('common.see_less') : $t('common.see_more') }}
        <van-icon :name="showAll ? 'arrow-up' : 'arrow-down'" size="14"></van-icon>
      </div>
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  lines: {
    type: Number,
    default: null
  }
})

const rerenderKey = ref(1)
const showAll = ref(false)
const contentWrapper = ref(null)
const shouldShowButton = ref(false)

const checkContentHeight = () => {
  if (contentWrapper.value && props.lines) {
    const actualHeight = contentWrapper.value.scrollHeight
    const maxHeight = 1.5 * props.lines * parseFloat(getComputedStyle(contentWrapper.value).fontSize)
    shouldShowButton.value = actualHeight > maxHeight
  }
}

onMounted(() => {
  setTimeout(() => {
    nextTick(() => checkContentHeight())
    rerenderKey.value++
  }, 100)
})

const toggleCollapse = () => {
  showAll.value = !showAll.value
  rerenderKey.value++
}
</script>

<style scoped>
.text-truncate {
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>